module.exports = __webpack_public_path__ + "img/agronor.9c7c4a7b.png";